import { IFacetValuesEntity } from '../../../actions/DataServiceEntities.g';

const parseFractionalNumber = (s: string): number => {
    const parts = s.trim().split(' ');
    if (parts.length === 2) {
        const whole = parseFloat(parts[0]) || 0;
        const [num, denom] = parts[1].split('/').map(Number);
        return whole + (num && denom ? num / denom : 0);
    } else if (parts.length === 1) {
        if (s.includes('/')) {
            const [num, denom] = s.split('/').map(Number);
            return num && denom ? num / denom : NaN;
        }
        return parseFloat(parts[0]);
    }
    return NaN;
};

const extractDimensions = (s: string): number[] => {
    if (!s) {
        return [];
    }
    const parts = s.split(/x/i).map(p => p.trim());
    return parts.map(parseFractionalNumber);
};

export const numericAwareValueCompare = (a?: IFacetValuesEntity, b?: IFacetValuesEntity): number => {
    const sa = String(a?.Value ?? '');
    const sb = String(b?.Value ?? '');

    const da = extractDimensions(sa);
    const db = extractDimensions(sb);

    for (let i = 0; i < Math.max(da.length, db.length); i++) {
        const na = da[i] ?? NaN;
        const nb = db[i] ?? NaN;

        if (!Number.isNaN(na) && !Number.isNaN(nb)) {
            if (na < nb) {
                return -1;
            }
            if (na > nb) {
                return 1;
            }
        } else if (!Number.isNaN(na)) {
            return -1;
        } else if (!Number.isNaN(nb)) {
            return 1;
        }
    }

    return sa.localeCompare(sb, undefined, { numeric: true });
};
